var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgShieldCheckRegular = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 99,
    viewBox: "0 0 93 99",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.284 16.185 50.084.716A9.135 9.135 0 0 0 46.512 0a9.17 9.17 0 0 0-3.577.715L5.737 16.185C2.273 17.61 0 20.998 0 24.575 0 74.52 36.696 99 46.48 99 56.034 99 93 74.888 93 24.575c0-3.577-2.267-6.965-5.716-8.39zM46.5 89.719c-18.89-7.85-37.2-32.234-37.2-64.97L46.5 9.28l37.2 15.469c0 33.606-19.065 57.429-37.2 64.97zm-10.83-41.96c-.737-.909-1.938-1.527-3.12-1.527-2.656 0-4.65 2.167-4.65 4.64 0 1.354.446 2.553 1.356 3.287l9.3 9.282c.872 1.044 2.073 1.353 3.294 1.353.503 0 2.22-.096 3.53-1.62l18.6-21.656a4.622 4.622 0 0 0 1.12-3.02c0-1.432-1.122-4.639-4.646-4.639a4.653 4.653 0 0 0-3.534 1.617L41.598 53.502l-5.929-5.743z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShieldCheckRegular, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/shield-check-regular.d17e6773.svg";
export { ForwardRef as ReactComponent };